import React from 'react';
import Header from '../component/Header'
import SubBanner from '../component/SubBanner'
import LegalContnet from '../component/LegalContnet'
import Footer from '../component/Footer'
import '../scss/legal-contnet.scss'
import '../scss/sub-banner.scss'

function LegalAccessibility() {

  return (
    <>
      <main className='main home-page'>
        <Header />   
        <SubBanner HeaderTitle="Legal Notices and Information" />     
        <LegalContnet /> 
      </main>
      <Footer />
    </>
  )
}
export default LegalAccessibility 


